import React, { useRef, useEffect } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Din Mapbox Access Token
mapboxgl.accessToken =
  "pk.eyJ1IjoibHVpYjEiLCJhIjoiY21scGdkbXRhMWF5MTNlczZmaDNnNHcyOCJ9._Sbc_B9XoahWQ0d-JStuag";

const WebGLMap = () => {
  const mapContainer = useRef(null);

  useEffect(() => {
    // Scroll til top når komponent loader
    window.scrollTo({ top: 0, behavior: "auto" });

    const isMobile = window.innerWidth < 768;

    const map = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/luib1/cmlpgq9p2001501s2hb7c0aa6",
      center: [12.52625, 55.683694],
      zoom: 17,
      pitch: isMobile ? 30 : 60,
      bearing: isMobile ? 180 : 240,
      antialias: true,
    });

    // Marker element
    const el = document.createElement("img");
    el.src = "https://i.imgur.com/BsawgzM.png";
    el.style.width = "25px";
    el.style.height = "40px";
    el.style.cursor = "pointer";

    // Popup med adresse – altid åben
    const popup = new mapboxgl.Popup({ offset: 10, closeOnClick: false })
      .setLngLat([12.52625, 55.683694])
      .setHTML(`
        <div style="text-align:center; background:#3a0000; padding:10px; border-radius:10px;">
          <h3>Nyelandsvej 51</h3>
          <p>2000 Frederiksberg</p>
        </div>
      `)
      .addTo(map);

    // Marker (popup er allerede åben)
    new mapboxgl.Marker(el)
      .setLngLat([12.52625, 55.683694])
      .addTo(map);

    return () => map.remove();
  }, []);

  return (
    <div
      ref={mapContainer}
      style={{
        width: "100%",
        height: "450px",
        minHeight: "400px",
      }}
    />
  );
};

export default WebGLMap;